module.exports = __webpack_public_path__ + "static/img/IchiyanagiToshi_lettertoGeorgeBrecht_2July1961_p2.de2437c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/IchiyanagiToshi_lettertoGeorgeBrecht_2July1961_p2.jpg
// module id = amqA
// module chunks = 0